import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';
import { TIER_ORDER, TIER_THRESHOLDS, TIER_LABELS } from '../../config/house.config';

export default function MembershipPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const member = useStore(s => s.getMember());
  if (!member) return null;

  const currentIdx = TIER_ORDER.indexOf(member.access_tier);
  const nextTier = currentIdx < TIER_ORDER.length - 1 ? TIER_ORDER[currentIdx + 1] : null;
  const nextThreshold = nextTier ? TIER_THRESHOLDS[nextTier] : null;
  const remaining = nextThreshold ? nextThreshold - member.yearly_spend_eur : 0;

  return (
    <div className="space-y-8 max-w-lg">
      <h1 className="font-serif text-2xl tracking-widest">{t('membership.title')}</h1>

      <div className="space-y-4">
        <div className="flex justify-between border-b border-charcoal/5 pb-3">
          <span className="text-[11px] tracking-widest uppercase text-charcoal/40 font-sans">{t('membership.currentTier')}</span>
          <span className="font-serif text-lg">{TIER_LABELS[member.access_tier]}</span>
        </div>
        <div className="flex justify-between border-b border-charcoal/5 pb-3">
          <span className="text-[11px] tracking-widest uppercase text-charcoal/40 font-sans">{t('membership.yearlySpend')}</span>
          <span className="font-sans text-sm">€{member.yearly_spend_eur.toLocaleString()}</span>
        </div>
        <div className="flex justify-between border-b border-charcoal/5 pb-3">
          <span className="text-[11px] tracking-widest uppercase text-charcoal/40 font-sans">{t('membership.lifetimeSpend')}</span>
          <span className="font-sans text-sm">€{member.lifetime_spend_eur.toLocaleString()}</span>
        </div>
        {nextTier && (
          <>
            <div className="flex justify-between border-b border-charcoal/5 pb-3">
              <span className="text-[11px] tracking-widest uppercase text-charcoal/40 font-sans">{t('membership.nextTier')}</span>
              <span className="font-serif">{TIER_LABELS[nextTier]}</span>
            </div>
            <div className="flex justify-between border-b border-charcoal/5 pb-3">
              <span className="text-[11px] tracking-widest uppercase text-charcoal/40 font-sans">{t('membership.remaining')}</span>
              <span className="font-sans text-sm text-gold">€{Math.max(0, remaining).toLocaleString()}</span>
            </div>
          </>
        )}
      </div>

      {/* Tier Ladder */}
      <div>
        <p className="text-[10px] tracking-widest-xl uppercase text-charcoal/30 font-sans mb-4">{t('membership.tierLadder')}</p>
        <div className="space-y-2">
          {TIER_ORDER.map((tier, i) => {
            const active = i <= currentIdx;
            return (
              <div key={tier} className={`flex items-center justify-between p-3 border transition-colors ${active ? 'border-gold/30 bg-gold/5' : 'border-charcoal/5'}`}>
                <span className={`font-serif text-sm ${active ? 'text-charcoal' : 'text-charcoal/30'}`}>{TIER_LABELS[tier]}</span>
                <span className={`text-[10px] font-sans ${active ? 'text-gold' : 'text-charcoal/20'}`}>€{TIER_THRESHOLDS[tier].toLocaleString()}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
